(function() {
	'use strict';
	angular.module('crewProfile').directive('otherHubHourSearch',
			otherHubHourSearch).directive('focusOn', function($timeout) {
		return {
			restrict : 'A',
			link : function(vm, $element, $attr) {
				vm.$watch($attr.focusOn, function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	});
	function otherHubHourSearch() {
		return {
			restrict : 'EA',
			scope : {
				onSearchOtherHubHours : '&', 
				addNewHubHours : '&',
				importHubHours : '&',
				deleteHubHours : '&',
				model : '=',
				type : '=',
				isImportPrivExist : '=',
				selectedCrewProfileId : '='
			},
			templateUrl : 'profile/directives/other-hub-hour-search-derective.tpl.html',
			replace : false,
			controllerAs : 'searchPanel',
			bindToController : true,
			controller : [
					'$scope',
					function($scope) {
						var vm = this;
						vm.model = {
							fromDate : '',
							toDate : '',
							crewProfileId : vm.selectedCrewProfileId,
							type : vm.type,
							isImportPrivExist : vm.isImportPrivExist,
							masterList : {
								fromDateAfterToDate : false,
								fromDateFormatInvalid : false,
								toDateFormatInvalid : false
							}
						};

						vm.onDateChange = function() {
							setDateValidationFlags();
						};

						function isDateFormatInvalid(date) {
							if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
								return true;
							}
							return false;
						}
						;

						// check from date and to date
						function istoDateBeforeFromDate() {
							return moment(vm.model.toDate, "DD/MM/YYYY")
									.isBefore(
											moment(vm.model.fromDate,
													"DD/MM/YYYY"));
						}
						;

						function setDateValidationFlags() {
							// if from date invalid
							if (isDateFormatInvalid(vm.model.fromDate)) {
								vm.model.masterList.fromDateFormatInvalid = true;
								vm.model.masterList.fromDateAfterToDate = false;
							} else {
								vm.model.masterList.fromDateFormatInvalid = false;
							}
							// if to date invalid
							if (isDateFormatInvalid(vm.model.toDate)) {
								vm.model.masterList.toDateFormatInvalid = true;
								vm.model.masterList.fromDateAfterToDate = false;
							} else {
								vm.model.masterList.toDateFormatInvalid = false;
							}
							//if from date is after to date
							if (!vm.model.masterList.fromDateFormatInvalid
									&& !vm.model.masterList.toDateFormatInvalid
									&& istoDateBeforeFromDate()) {
								vm.model.masterList.fromDateAfterToDate = true;
							} else {
								vm.model.masterList.fromDateAfterToDate = false;
							}
						}
						;

						function isValidSearchParams() {
							setDateValidationFlags();
							// if date invalid
							if (vm.model.masterList.fromDateFormatInvalid
									|| vm.model.masterList.toDateFormatInvalid) {
								vm.model.masterList.fromDateAfterToDate = false;
								return false;
							} else if (istoDateBeforeFromDate()) {
								vm.model.masterList.fromDateAfterToDate = true;
								return false;
							}
							vm.model.masterList.fromDateAfterToDate = false;
							return true;
						}

						//when click on 
						vm.onSearchClick = function() {
							if (isValidSearchParams())
								vm.onSearchOtherHubHours({
									'param' : vm.model.type
								});
						};
						
						//when click on add
						vm.addNewHubHoursClick = function(){
							vm.addNewHubHours();
						};
						
						//when click on import
						vm.importHubHoursClick = function(){
							vm.importHubHours();
						};
						
						//when click on delete
						vm.deleteHubHoursClick = function(){
							vm.deleteHubHours();
						}
						
					} ],
			link : function(scope, element, attrs) {
			}
		};
	}
}());